/* Store 01 — Live chat launcher
   ------------------------------------------------------------------
   Opens whichever live-chat widget the store has installed, triggered by any
   element with [data-s01-open-chat]. The chat widget is a third-party app embed
   (not in the theme), so we detect its API at click time and fall back through
   the common providers, then to a floating launcher, then to a visible hint. */
(function () {
  function openChat() {
    try {
      var w = window;

      // Shopify Inbox
      if (w.Shopify && w.Shopify.chat && typeof w.Shopify.chat.open === 'function') { w.Shopify.chat.open(); return true; }
      // Tawk.to
      if (w.Tawk_API && typeof w.Tawk_API.maximize === 'function') { w.Tawk_API.maximize(); return true; }
      // Crisp
      if (w.$crisp && typeof w.$crisp.push === 'function') { w.$crisp.push(['do', 'chat:open']); return true; }
      // Tidio
      if (w.tidioChatApi && typeof w.tidioChatApi.open === 'function') { w.tidioChatApi.open(); return true; }
      // Intercom
      if (typeof w.Intercom === 'function') { w.Intercom('show'); return true; }
      // Zendesk (messenger, then legacy web widget)
      if (typeof w.zE === 'function') {
        try { w.zE('messenger', 'open'); } catch (e) { try { w.zE('webWidget', 'open'); } catch (e2) {} }
        return true;
      }
      // LiveChat
      if (w.LiveChatWidget && typeof w.LiveChatWidget.call === 'function') { w.LiveChatWidget.call('maximize'); return true; }
      // Gorgias
      if (w.GorgiasChat && typeof w.GorgiasChat.open === 'function') { w.GorgiasChat.open(); return true; }
      // Chatra
      if (typeof w.Chatra === 'function') { w.Chatra('openChat', true); return true; }
      // HubSpot
      if (w.HubSpotConversations && w.HubSpotConversations.widget && typeof w.HubSpotConversations.widget.open === 'function') {
        w.HubSpotConversations.widget.open(); return true;
      }
      // Smartsupp
      if (typeof w.smartsupp === 'function') { w.smartsupp('chat:open'); return true; }
      // Re:amaze
      if (w.reamaze && typeof w.reamaze.popup === 'function') { w.reamaze.popup(); return true; }
      // Facebook Messenger customer chat
      if (w.FB && w.FB.CustomerChat && typeof w.FB.CustomerChat.showDialog === 'function') { w.FB.CustomerChat.showDialog(); return true; }

      // Generic fallback: click a detected floating launcher button.
      var el = document.querySelector(
        '#shopify-chat button,' +
        'button[aria-label*="chat" i],' +
        'a[aria-label*="chat" i],' +
        '[role="button"][aria-label*="chat" i],' +
        '[class*="launcher"][class*="chat" i],' +
        '[id*="chat"][id*="launcher" i],' +
        '.gorgias-chat-container button'
      );
      if (el && typeof el.click === 'function') { el.click(); return true; }
    } catch (e) {
      /* ignore — fall through to hint */
    }
    return false;
  }

  window.S01OpenChat = openChat;

  function trigger() {
    if (openChat()) return;
    // No widget yet — show the hint and retry once in case it was still loading.
    var hint = document.querySelector('[data-s01-chat-fallback]');
    if (hint) hint.hidden = false;
    setTimeout(function () {
      if (openChat() && hint) hint.hidden = true;
    }, 800);
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-s01-open-chat]');
    if (!t) return;
    e.preventDefault();
    trigger();
  });

  // Keyboard support for non-<button> triggers (e.g. the header chip).
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var t = e.target.closest('[data-s01-open-chat]');
    if (!t || t.tagName === 'BUTTON') return;
    e.preventDefault();
    trigger();
  });
})();
